import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

// Product feature/advantage texts are Markdown (links, **bold**, "- " lists), some still with HTML.
// Lines migrated from Drupal are indented with tabs, which Markdown would render as code blocks.
// The tabs carry Drupal's list nesting, though (e.g. Bill Payments "Data offered": "Daily
// transactions" > "List of transactions" > "Creditor, debitor, ..."), so instead of dropping all
// indentation, list items are re-indented to their nesting level. A plain indented line counts as
// a list item only when deeper items follow it (a sub-heading like "List of transactions");
// other indented lines are ordinary paragraphs and lose their indentation.
const MARKER = /^([-*+]|\d{1,3}[.)])\s/;
const depthOf = (indent) =>
  (indent.match(/\t/g) || []).length +
  Math.floor(indent.replace(/\t/g, "").length / 4);

const normalize = (text) => {
  const lines = (text || "").replace(/\r/g, "").split("\n");
  const parsed = lines.map((line) => {
    const m = line.match(/^([ \t]*)(.*)$/);
    return { depth: depthOf(m[1]), content: m[2], blank: m[2].trim() === "" };
  });
  const out = [];
  const levels = []; // depths of the open list levels
  parsed.forEach((line, i) => {
    if (line.blank) {
      out.push("");
      return;
    }
    const isItem = MARKER.test(line.content);
    let isParent = false;
    if (!isItem && line.depth > 0) {
      const next = parsed.slice(i + 1).find((l) => !l.blank);
      isParent = !!next && next.depth > line.depth && MARKER.test(next.content);
    }
    if (!isItem && !isParent) {
      levels.length = 0;
      out.push(line.content.trim());
      return;
    }
    while (levels.length && levels[levels.length - 1] > line.depth)
      levels.pop();
    if (!levels.length || levels[levels.length - 1] < line.depth)
      levels.push(line.depth);
    const text = isItem ? line.content.trim() : "- " + line.content.trim();
    out.push("    ".repeat(levels.length - 1) + text);
  });
  return out.join("\n");
};

const ProductMarkdown = ({ text }) => (
  <ReactMarkdown
    rehypePlugins={[rehypeRaw]}
    components={{
      a: ({ node, ...props }) => (
        <a target="_blank" rel="noopener noreferrer" {...props} />
      ),
    }}
  >
    {normalize(text)}
  </ReactMarkdown>
);

export default ProductMarkdown;
